/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import ModalComponent from './ModalComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import ThreeDotsLoader from '../Loaders/ThreeDotsLoader';
import AddressForm from '../../Dashboard/Lists/components/AddressForm';
import { dayjs } from '../../../utils/dayjs-utils';
import { refuseGift, updateUserAddress } from '../../../services/user.service';
import { TransparentButton } from '../../styledComponents';
import editIcon from '../../../images/icons/edit.svg';

export default function HandWryttenModal() {
  const [showHandWryttenModal, setShowHandWryttenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState({
    addressLineOne: '',
    addressLineTwo: '',
    pincode: '',
    city: '',
    state: '',
    country: '',
  });
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const { userDetails } = useSelector((state) => state.user);

  const checkIfDisabled = () => {
    if (!address?.addressLineOne || !address?.pincode || !address?.city || !address?.country) {
      return true;
    } else {
      return false;
    }
  };

  const formatAddress = () => {
    let addressString = 'Please add your address...';
    if (address.addressLineOne) {
      addressString = `${address.addressLineOne}, ${address?.addressLineTwo ? address?.addressLineTwo + ',' : ''} ${
        address.city
      }, ${address.pincode}, ${address.state}, ${address.country}`;
    }
    return addressString;
  };

  const handleClose = async () => {
    setShowHandWryttenModal(false);
  };

  const handleRefuseGift = async () => {
    const response = await refuseGift();
    if (response?.status) {
      handleClose();
    }
  };

  const handleSend = async () => {
    setLoading(true);
    const addressObject = {
      line1: address?.addressLineOne,
      line2: address?.addressLineTwo,
      postal_code: address?.pincode,
      city: address?.city,
      state: address?.state,
      country: address?.country,
    };
    const response = await updateUserAddress({ addressObject });
    if (response?.status) {
      NotificationManager.success(`We'll send it soon!`, '', 1500);
      setLoading(false);
      handleClose();
    } else {
      // NotificationManager.error('There was a problem updating your address, please try again later', '', 1500);
      NotificationManager.error('Something went wrong', '', 1500);
      setLoading(false);
    }
  };

  const checkGiftCardEligibity = async () => {
    if (userDetails?.address) {
      setAddress({
        addressLineOne: userDetails?.address?.line1,
        addressLineTwo: userDetails?.address?.line2,
        pincode: userDetails?.address?.postal_code,
        city: userDetails?.address?.city,
        state: userDetails?.address?.state,
        country: userDetails?.address?.country,
      });
    }

    if (['sent', 'refused', 'eligible'].includes(userDetails?.giftCardStatus)) {
      setShowHandWryttenModal(false);
      return;
    }
    const currentDate = dayjs(new Date());
    const userUpgradedAt = dayjs(userDetails?.upgradedAt);
    if (
      currentDate.diff(userUpgradedAt, 'day') > 3 &&
      userDetails?.giftCardStatus === null &&
      userDetails?.subscriptionStatus === 'active'
    ) {
      setShowHandWryttenModal(true);
    }
  };

  useEffect(() => {
    checkGiftCardEligibity();
  }, []);

  return (
    <>
      <ModalComponent
        show={showHandWryttenModal && !isEditingAddress}
        onClose={handleClose}
        width={450}
        outsideClickClose={false}>
        <div className="warning-modal modal-main-content">
          <IconContainer icon="🎁" />
          <h2>We want to surprise you!</h2>
          <p className="enter-list-name" style={{ fontSize: 14 }}>
            Can you confirm if this is the right address to ship to?
          </p>

          <div className="address-view-section">
            <div className="top-div">
              <label>Address</label>
              <button onClick={() => setIsEditingAddress(true)}>
                <img src={editIcon} alt="" />
                Edit
              </button>
            </div>
            <div className="bottom-div">
              <p>{formatAddress()}</p>
            </div>
          </div>

          <div className="extension-modal-footer-button-container">
            {loading ? (
              <ButtonComponent>
                <ThreeDotsLoader />
              </ButtonComponent>
            ) : (
              <ButtonComponent onClick={handleSend} variant="primary" disabled={checkIfDisabled()}>
                Yes! Send me my gift!
              </ButtonComponent>
            )}
            <TransparentButton className="btn2" onClick={handleRefuseGift} style={{ marginTop: 2 }}>
              I don&apos;t like gifts
            </TransparentButton>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        show={showHandWryttenModal && isEditingAddress}
        onClose={handleClose}
        width={500}
        outsideClickClose={false}>
        <div className="warning-modal modal-main-content">
          <h2 style={{ marginTop: 0, marginBottom: 20 }}>Edit shipping address</h2>
          <div style={{ width: '100%', marginBottom: 8 }}>
            <AddressForm address={address} setAddress={setAddress} showPhone={false} />
          </div>
          <div className="modal-footer-button-container">
            <ButtonComponent onClick={() => setIsEditingAddress(false)} variant="secondary">
              Go Back
            </ButtonComponent>
            {loading ? (
              <ButtonComponent>
                <ThreeDotsLoader />
              </ButtonComponent>
            ) : (
              <ButtonComponent onClick={handleSend} variant="primary" disabled={checkIfDisabled()}>
                Send it here!
              </ButtonComponent>
            )}
          </div>
        </div>
      </ModalComponent>
    </>
  );
}
